import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import axiosInstance from "./AxiosConfig";

export class HttpClientNormal {
  private instance: AxiosInstance;
  
  constructor() {
    this.instance = axiosInstance;
  }

  get(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.instance.get(url, options);
  }

  post(
    url: string,
    data: object = {},
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return this.instance.post(url, data, options);
  }

  put(
    url: string,
    data: object = {},
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return this.instance.put(url, data, options);
  }

  patch(
    url: string,
    data: object = {},
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    return this.instance.patch(url, data, options);
  }

  delete(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.instance.delete(url, options);
  }
}
